import React from "react";
import { Trans } from "@lingui/macro";
import {
  Modal as BaseModal,
  ModalProps,
  BaseModalProps
} from "@silversea-ssc/ui-components-react";

const Modal: React.FC<ModalProps> = ({ children, ...props }) => {
  return (
    <BaseModal
      {...props}
      labels={{ close: <Trans id="Modal close button label">Close</Trans> }}
    >
      {children}
    </BaseModal>
  );
};

export type { BaseModalProps, ModalProps };
export default Modal;
